import { CopperOpportunityStatus } from '../../../__generated__/graphql'

export const DEFAULT_COPPER_OPPORTUNITY_STAGE = 'OI signé / En attente de mise en ligne'

export const ALL_COPPER_OPPORTUNITY_STATUSES = Object.values(CopperOpportunityStatus)
